import Vue from 'vue';

import SimplePage from './simple-page';

Vue.component('uikit:simple-page', SimplePage);



// WEBPACK FOOTER //
// ./src.common/uikit/components/index.js